import { render } from "./ViewResults.vue?vue&type=template&id=bfd5a2b0&scoped=true"
import script from "./ViewResults.vue?vue&type=script&lang=js"
export * from "./ViewResults.vue?vue&type=script&lang=js"

import "./ViewResults.vue?vue&type=style&index=0&id=bfd5a2b0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd5a2b0"]])

export default __exports__